var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SChip,{attrs:{"color":_setup.chip.color,"text":_setup.chip.text,"icon":_setup.chip.icon,"emphasize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }